import React from 'react';
import { Navigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

const SigninRoute = ({ children }: Props) => {
  const token = localStorage.getItem('token');
  const firstname = localStorage.getItem('firstname');

  if (token && firstname) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default SigninRoute;
